import { createContext, FC, useContext } from 'react';

// TODO Delete this file when EnableContextBarVisualUpgrades and EnableContextBarOtherPage have been removed

type CrmContextType = {
  entityType: 'client' | 'company';
  entityId: string;
  closeSidebarOnMobile?: () => void;
};

const CrmContext = createContext<CrmContextType | undefined>(undefined);

export const CrmProvider: FC<CrmContextType> = ({
  entityType,
  entityId,
  closeSidebarOnMobile,
  children,
}) => (
  <CrmContext.Provider
    value={{
      entityType,
      entityId,
      closeSidebarOnMobile,
    }}
  >
    {children}
  </CrmContext.Provider>
);

export const useCrmContext = () => {
  return useContext(CrmContext);
};
